<template>
	<div class="d-flex">
		<v-select
			placeholder="Select a route"
			class="flex-grow-1"
	        label="title"                                
	        :options="options.routes"
	        :reduce="title => title.id"
	        v-model="selected"
		/>
		<span class="btn btn-primary ml-1 text-nowrap" @click="addRouteStop()">Add to Route</span>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		props: ['location_id'],

		data() {
			return {
				routes: null,
				selected: null,
			}
		},

		// mounted() {
		// 	axios.get('/api/routes/ids').then(({data}) => {
		// 		this.routes = data;
		// 	});
		// },

		methods: {
			addRouteStop() {
				axios.post(`/api/route-visits/store`, { 
					added_visits: [this.location_id],
					type: 'planned',
					route_id: this.selected,
				}).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 4000,
	                    icon: 'success',
	                    title: 'Route visit saved'
	                });

	                this.$emit('route_visit_added', data);
	            });									
			},

		},

		computed: mapState(['options'])
	}
</script>